export default `
query productDetails(
	$search: String = ""
	$filter: ProductAttributeFilterInput
	$pageSize: Int = 10
	$currentPage: Int = 1
	$sort: ProductAttributeSortInput
) {
	products(
		search: $search
		filter: $filter
		sort: $sort
		pageSize: $pageSize
		currentPage: $currentPage
	) {
		items {
      before_test_preparations
      medication_preparations
      food_and_alcohol_preparations
		}
	}
}
`;
